import vueSeamlessScroll from "vue-seamless-scroll";
import moment from "moment";
import "moment/locale/zh-cn";
import Speech from "speak-tts";
import {
  detailBySchoolNo,
  listBySchoolNo,
  doCard
} from "@/api/api.js";


let myMixin = {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      // 是否已经回调了 获取本地发音人 标记
      isFallBack: false,
      speech: null,
      schoolNo: "",
      scoolName: "",
      scoolLogo: "",



      dateTimeObj: {
        currentDate: "",
        currentTime: "",
      },


      weifxArr: [], // 未放学
      fxzhongArr: [], // 放学中
      yifxArr: [], // 已放学

      footerArr: [{
          class: "redC",
          text: "红色代表未放学"
        },
        {
          class: "purpleC",
          text: "紫色代表放学中"
        },
        {
          class: "greenC",
          text: "绿色代表已放学"
        },
      ],
      totalNum: 0, // 总的班级数量
      noticeText: "", // 通知文本
      voiceText: "初始语音", // 广播通知的语音

      iswhileing: false, // 是否正在循环播放中,是否已经触发循环播放

      /////////////////////////////////////////////////////////
      voiceClassList: [], // 需要按次数播放的班级名列表
      params: {
        reportType: '', // 播报类型
        reportNumber: 0, // 播报次数
        repeatDoCardInterval: 0, // 重复刷卡间隔(秒)
        doCardType: '', // 刷卡类型
        classUpdateFrequency: 0, // 班级更新频率(秒)
        ttsType: null, // 发音人类型
        ttsRate: null // 发音人语速
      },
      // 播报类型:
      // 连续播报 continuous_broadcast
      // 次数播报 number_broadcast

      // 刷卡类型:
      // 直连模式 direct_mode
      // 网络模式 network_model

      numberPlayClassName: ''  // 正在次数播放模式的班级



    };
  },
  computed: {
    // 公告滚动自定义——未放学，已放学
    defaultOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 16, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    // 公告滚动自定义——放学中
    defaultOption2() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 8, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    // 处理发音人
    handleVoices(speechSynthesis) {
      const voices = speechSynthesis.getVoices();
      let voicesTrue = [];
      if (voices) {
        voicesTrue = voices.filter((vv) => {return vv.localService});
      }
      console.log('可用的语音列表：', voicesTrue);
      console.log('后台配置的发音人：', this.params.ttsType);
      let backVoice = voicesTrue.filter((vvv) => vvv.name == this.params.ttsType)[0];
      // 如果后台配置的发音人未找到 则赋值发音人为空 使用当前系统默认的发音人
      if (!backVoice) {
        console.log("未匹配到后台设置的发音人 使用系统默认发音人")
        this.params.ttsType = null;
      }
      this.isFallBack = true;
    },
    // 确保浏览器支持 SpeechSynthesis API
    async getAvailableVoices() {
      if ('speechSynthesis' in window) {
        // 在 SpeechSynthesis 初始化完成后获取所有可用的声音
        window.speechSynthesis.onvoiceschanged = () => {
          this.handleVoices(speechSynthesis);
        };
        // 兼容火狐浏览器 在 Firefox 浏览器中，speechSynthesis.onvoiceschanged 事件的触发机制与其他浏览器有所不同。在 Firefox 中，该事件不是在 SpeechSynthesis 初始化完成后立即触发，而是在获取语音列表时触发
        const isFirefox = typeof InstallTrigger !== 'undefined';
        if (isFirefox) {
          console.log("火狐浏览器特殊处理 Voices");
          this.handleVoices(speechSynthesis);
        }
      } else {
        console.log('浏览器不支持 SpeechSynthesis API');
        this.isFallBack = true;
      }
    },
    // 初始化 语音播报
    async speechInit() {
      this.speech = new Speech();
      this.speech.setLanguage("zh-CN");
      let rate = this.params.ttsRate ? this.params.ttsRate : 1;
      let voice = this.params.ttsType ? this.params.ttsType : null;
      console.log("当前使用的语速：" + rate + " 发音人：" + voice);
      return this.speech.init({
        // 发音人语速 默认1
        'rate': rate,
        // 发音人类型 默认空（系统默认）
        'voice': voice
      }).then(() => {});
    },
    // 取出最新的 并且 没有播报过的className班级名称
    getNotPlayClassName() {
      let className = null;
      for (let i = 0; i < this.fxzhongArr.length; i++) {
        let item = this.fxzhongArr[i];
        if (!this.voiceClassList.includes(`现在${item.className.replace(/[()（）"“”]/g, "")}正在放学。`)) {
          className = item.className;
          break;
        }
        // 最后一个没播报则一直播最后一个
        if (this.fxzhongArr[this.fxzhongArr.length - 1].className == item.className) {
          className = item.className;
          break;
        }
      }
      return className
    },
    // 循环播放 isFirstExec是否首次执行循环 首次至少播放 后台设置的播报次数
    cyclePlay(isFirstExec) {
      // 取出最新的 并且 没有播报过的className班级名称
      let className = this.getNotPlayClassName();

      console.log("当前放学中数组", this.fxzhongArr)
      console.log("当前放学中已播报数组", this.voiceClassList)

      this.voiceText = `现在${className.replace(/[()（）"“”]/g, "")}正在放学。`;
      // 没有播放过则至少播放 重复后台设置的次数
      if (!this.voiceClassList.includes(this.voiceText)) {
        isFirstExec = true
      }
      let currentVoice = isFirstExec ? this.voiceText.repeat(this.params.reportNumber) : this.voiceText;
      console.log("当前播放的语音：", currentVoice)
      this.speech
        .speak({
          // isFirstExec是否首次执行循环 首次至少播放 后台设置的播报次数
          text: currentVoice,
          listeners: {
            onend: () => {
              // 播放后放入已播放数组
              if (!this.voiceClassList.includes(this.voiceText)) {
                this.voiceClassList.push(this.voiceText);
              }
              console.log("语音播报成功:" + this.voiceText);
              if (this.totalNum > this.yifxArr.length && this.voiceText) {
                this.cyclePlay(false);
              } else {
                // 已放学数量等于总数量，或this.voiceText文字为空，则结束循环播放
                this.iswhileing = false
              }
            },
          },
        })
        .then(() => {})
        .catch((e) => {
          console.error(e);
        });
    },


    // 根据学校编号获取学校名称
    async getDetailBySchoolNo() {
      return detailBySchoolNo({
        schoolNo: this.schoolNo
      }).then((res) => {
        this.scoolLogo = res.data.schoolLogo;
        this.scoolName = res.data.schoolName;
        this.params.reportType = res.data.reportType
        this.params.reportNumber = res.data.reportNumber
        this.params.repeatDoCardInterval = res.data.repeatDoCardInterval
        this.params.doCardType = res.data.doCardType
        this.params.classUpdateFrequency = res.data.classUpdateFrequency
        this.params.ttsType = res.data.ttsType
        this.params.ttsRate = res.data.ttsRate
      });
    },

    // 获取该学校的所有班级信息，然后根据【播放模式】处理数据
    getListBySchoolNo(playMode) {
      return listBySchoolNo({
        schoolNo: this.schoolNo
      }).then((res) => {

        // 未放学的班级列表
        this.weifxArr = res.data.filter((item) => item.leaveStatus == 0);

        // 放学中的班级列表
        let newArr = res.data.filter((item) => item.leaveStatus == 1);
        newArr.sort(function (a, b) {
          if (a.updateTime < b.updateTime) {
            // 按某种排序标准进行比较, a 小于 b
            return -1;
          } else if (a.updateTime > b.updateTime) {
            return 1;
          } else {
            return 0;
          }
        });
        this.fxzhongArr = newArr;

        // 已放学的班级列表
        this.yifxArr = res.data.filter((item) => item.leaveStatus == 2);
        this.totalNum = res.data.length;
        this.changeNotice();

        if (playMode == 'continuousPlay') {
          this.continuousPlay()
        } else if (playMode == 'numberPlay') {
          this.numberPlay()
        }else{
          console.log('播放模式错误！');
        }


      });
    },

    // 连续播放
    continuousPlay() {
      if (this.fxzhongArr.length == 0) {
        // 还没放学完全，放学中为空
        this.iswhileing && (this.voiceText = '');

        // 全部放学完毕
        if (this.yifxArr.length == this.totalNum && this.iswhileing) {
          this.voiceText = "";
          this.iswhileing = false
          console.log("0000");
          let temp = "放学结束，所有班级正常离校，祝大家一路顺风！";
          this.speech.speak({
            text: temp.repeat(3),
            listeners: {
              onend: () => {
                console.log("放学结束");
              },
            },
          });
        }

      } else {
        // 当没有在循环播放时，则触发一下
        if (!this.iswhileing) {
          console.log(1111);
          this.cyclePlay(true);
          this.iswhileing = true;
        }
      }
    },


    // 次数播放
    numberPlay() {
      if (this.fxzhongArr.length == 0) {
        // 当全部放学完毕时
        if (this.yifxArr.length == this.totalNum && this.voiceClassList.length > 0) {
          console.log("0000");
          this.voiceClassList = []
          let temp = "放学结束，所有班级正常离校，祝大家一路顺风！";
          this.speech.speak({
            text: temp.repeat(3),
            listeners: {
              onend: () => {
                console.log("放学结束");
              },
            },
          });
        }

      } else {
        this.fxzhongArr.forEach(item => {
          // 如this.voiceClassList中没有，则播放，如果有了，说明播放过了，则忽略
          if (!this.voiceClassList.includes(item.className)) {
            this.voiceClassList.push(item.className)
            this.numberPlayClassName = item.className
            let text = `现在${item.className.replace(/[()（）"“”]/g, "")}正在放学。`
            this.speech.speak({
              text: text.repeat(this.params.reportNumber),
            }).then(() => {
              // 播放完成后置空
              this.numberPlayClassName = ''
            })
          }
        });

        // 如果正在次数播放，this.numberPlayClassName有值
        if(this.numberPlayClassName){
          this.yifxArr.forEach(item => {
            // 如果次数没播放完，就已经刷放学卡，到已放学的列表中了，这时取消播放
            if(item.className == this.numberPlayClassName){
              this.speech.cancel()
            }
          })
        }
      }
    },


    // 刷卡时触发此方法
    doCard(cardNo) {
      doCard({
        cardNo: cardNo
      }).then(async (res) => {
        if (res.code == 200) {
        } else {
          this.$message.error(res.message);
        }
      });
    },

    changeNotice() {
      if (this.weifxArr.length == this.totalNum) {
        this.noticeText = "现在还未放学，请家长耐心等待！";
      } else if (this.yifxArr.length == this.totalNum) {
        this.noticeText = "放学结束，所有班级正常离校，祝大家一路顺风！";
      } else {
        this.noticeText = "现在正在放学，请家长保持门口道路通畅！";
      }
    },


    // 处理刷卡类型
    dealDoCardType() {
      // 直连模式
      if (this.params.doCardType == 'direct_mode') {
        // 触发读卡循环
        // 自定义事件，携带数据
        window.directModeEvent = new CustomEvent('directMode-event', {
          detail: {},
        });

        // 随后在对应的元素上触发该事件
        if (window.dispatchEvent) {
          window.dispatchEvent(window.directModeEvent);
        } else {
          window.fireEvent(window.directModeEvent);
        }

        // 注册相关的EventListener
        window.addEventListener("doCard-event", (event) => {
          console.log("得到卡号为：", event.detail.cardNo);
          this.doCard(event.detail.cardNo);
        });

        // 注册相关的EventListener
        window.addEventListener("error-event", (event) => {
          this.$message.error(event.detail.error);
        });

      } else if (this.params.doCardType == 'network_model') { // 网络模式
        // 不作处理

      } else {
        this.$message.error("请设置正确的刷卡类型！");
      }
    },

    // 处理播报类型
    dealReportType() {
      // 连续播放还是次数播放的判断
      if (this.params.reportType == 'continuous_broadcast') {
        this.getListBySchoolNo('continuousPlay')
        setInterval(() => {
          this.getListBySchoolNo('continuousPlay')
        }, this.params.classUpdateFrequency * 1000);

      } else if (this.params.reportType == 'number_broadcast') {
        this.getListBySchoolNo('numberPlay')
        setInterval(() => {
          this.getListBySchoolNo('numberPlay')
        }, this.params.classUpdateFrequency * 1000);

      } else {
        this.$message.error("请设置正确的播报类型！");
      }
    }


  },
  async created() {
    this.dateTimeObj.currentDate = moment().format("YYYY-MM-DD dddd");
    this.dateTimeObj.currentTime = moment().format("HH:mm:ss");
    setInterval(() => {
      this.dateTimeObj.currentDate = moment().format("YYYY-MM-DD dddd");
      this.dateTimeObj.currentTime = moment().format("HH:mm:ss");
    }, 1000);

    // this.schoolNo = location.hostname.split('.')[0]
    this.schoolNo = this.$route.params.schoolNo;

    console.log(this.schoolNo);

    await this.getDetailBySchoolNo();

    // 确保浏览器支持 SpeechSynthesis API
    await this.getAvailableVoices();

    // 创建定时器，循环检查是否已经回调了 发音人 回调之后才可判断是否有 支持后台配置的发音人
    const intervalId = setInterval(async () => {
      // 检查达到某些条件
      if (this.isFallBack) {
        await (async () => {
          // 初始化语音播报
          await this.speechInit();

          this.dealDoCardType();

          this.dealReportType();
        })();
        // 达到条件，停止定时器
        clearInterval(intervalId);
      }
    }, 200);

  },

  mounted() {
    function fontSize() {
      var deviceWidth = document.documentElement.clientWidth;
      document.documentElement.style.fontSize = deviceWidth / 192 + "px";
      console.log(deviceWidth / 192 + "px");
    }
    fontSize();
    window.onresize = fontSize;

  },
}

export default myMixin;
